import type { Order } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (
	item?: Order.Model["executingStage"],
	t?: TFunction,
): string => (item && t ? t(`order_executing_stages.${item}`) : "");

export default cellProcessing;
